var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{'large-select': _vm.large}},[_c('v-select',{attrs:{"label":"label","options":_vm.options,"reduce":o => o.value,"placeholder":"Select a preference..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }